import { OnboardingDialog } from './onboarding-dialog';
import { useUserContext } from '../../../Contexts/User';
import { V2_ONBOARDING_CUTOFF_DATE } from '@/new/constants/onboarding';

interface SubsetCreationV2OnboardingProps {
  onTakeTour?: () => void;
}

/**
 * Onboarding dialog for the Subset creation page.
 */
export function SubsetCreationV2Onboarding({ onTakeTour }: SubsetCreationV2OnboardingProps) {
  const { user } = useUserContext();

  // Only show V2 onboarding to existing users (created before cutoff date)
  const userCreatedAt = user?.createdAt ? new Date(user.createdAt) : null;
  const isExistingUser = userCreatedAt && userCreatedAt < V2_ONBOARDING_CUTOFF_DATE;

  if (!isExistingUser) {
    return null;
  }
  return (
    <OnboardingDialog dialogId="subset-creation" icon="lucide--group" title="Creating a Subset" onTakeTour={onTakeTour}>
      <h3 className="text-lg font-medium">Welcome to the Subset creator</h3>
      <p>Select the documents you want to include and fill out the Subset issues.</p>
      <p>
        The Subset issues are used to determine the <strong>relevance</strong> and <strong>significance</strong> for
        facts viewed through this Subset.
      </p>
      <p className="text-xs text-gray-500">
        For example, if you're creating a Subset of all emails, there might be certain issues that you want to focus on
        to determine which facts are most relevant.
      </p>
      <p className="text-xs text-gray-500">Alternatively, you can just continue using the Matter level issues.</p>
    </OnboardingDialog>
  );
}
